import { Link } from 'react-router-dom'
import { Badge, Card, ErrorNote, LoadingBlock, Stat } from '../../components/ui'
import { useAnalytics, useOverview } from '../../hooks/useAdmin'
import { formatMicroDollars } from '../../utils/format'

export function AdminOverviewPage() {
  const overview = useOverview()
  const month = useAnalytics(30)
  if (overview.isPending) return <LoadingBlock />
  if (overview.isError) return <ErrorNote error={overview.error} />
  const { users, workspaces, shows, episodes, jobs, workers_online, providers, queue_backend } = overview.data
  return (
    <div className="stack-lg">
      <div className="grid-4">
        <Stat label="Users" value={users} />
        <Stat label="Workspaces" value={workspaces} note={`${shows} shows · ${episodes} episodes`} />
        <Stat label="Workers online" value={workers_online} note={`Queue: ${queue_backend}`} />
        <Stat label="Jobs running" value={jobs.leased} note={`${jobs.ready} queued`} />
      </div>
      {month.data && (
        <Card title="Last 30 days" actions={<Link to="/studio/admin/usage">Usage and spend</Link>}>
          <div className="grid-4">
            <Stat label="Provider spend" value={formatMicroDollars(month.data.totals.provider_cost_micros)} />
            <Stat label="Credits used, worth" value={formatMicroDollars(month.data.totals.credits_value_micros)} />
            <Stat label="Margin" value={formatMicroDollars(month.data.totals.margin_micros)} />
            <Stat label="Revenue" value={formatMicroDollars(month.data.totals.revenue_cents * 10_000)} note={`${month.data.totals.signups} signups`} />
          </div>
        </Card>
      )}
      <div className="grid-2">
        <Card title="Jobs" actions={<Link to="/studio/admin/jobs">Open queue</Link>}>
          <div className="grid-3">
            <Stat label="Succeeded" value={jobs.succeeded} />
            <Stat label="Failed" value={jobs.failed} />
            <Stat label="Queued" value={jobs.ready} />
          </div>
        </Card>
        <Card title="Providers" actions={<Link to="/studio/admin/providers">Manage keys</Link>}>
          <div className="stack-sm">
            <div className="row between"><span>OpenAI</span>{providers.openai ? <Badge tone="ok">Key set</Badge> : <Badge tone="warn">No key</Badge>}</div>
            <div className="row between"><span>TypeSafe</span>{providers.typesafe ? <Badge tone="ok">Key set</Badge> : <Badge tone="warn">No key</Badge>}</div>
            <div className="row between"><span>fal.ai</span>{providers.fal ? <Badge tone="ok">Key set</Badge> : <Badge tone="warn">No key</Badge>}</div>
            <div className="row between"><span>Stripe</span>{providers.stripe ? <Badge tone="ok">Key set</Badge> : <Badge tone="warn">No key</Badge>}</div>
            <div className="row between"><span>Cloudflare Stream</span>{providers.cloudflare ? <Badge tone="ok">Key set</Badge> : <Badge tone="warn">No key</Badge>}</div>
          </div>
        </Card>
      </div>
    </div>
  )
}
